import React from 'react';
import { Button, Image, RichText } from '@synergycms_core/components/generic';
import { compose } from 'ramda';
import styleFile from './AlertBlockPointsModal.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import ModalBox from '@synergycms_core/components/generic/Modal/ModalBox';
import actions from '../../../store/actions';
import {connect} from 'react-redux';


 class AlertBlockPointsModal extends React.Component {
  static displayName = 'AlertBlockPointsModal';


  onClick = accept => e => {
    const {closeModal, setBlockPoints, checkboxChange } = this.props.config;
    var promise = accept ? setBlockPoints() : Promise.resolve();
    return  promise.finally(()=>{
        checkboxChange(accept);
      }).then(()=>{
        closeModal();
      });


  }

  render() {
    const { closeModal } = this.props.config;
    const { theme } = this.props;
    const { classes } = theme.styles;

    return (
      <ModalBox close={closeModal} modalStyle={classes.modalStyle} contentStyle={classes.content} closeButtonStyle={classes.closeButton}>
        <div className={classes.contentBox}>
          <Image svg={'infoIcon'}/>
          <RichText
            translate={true}
            text={'_%¿Quieres continuar con el pago con puntos?%_'}
            innerStyle={'roboto22Black400'}
          />
          <RichText
            translate={true}
            ucFirst={true}
            text={'_%lo sentimos, solo puede realizar un pago con puntos simultáneamente. Por favor, confirma si quieres continuar con el pago con puntos en esta reserva o de lo contrario haz click en cancelar y selecciona otro método de pago.%_'}
            innerStyle={['roboto16BlackWide', classes.contentSubtitle]}
          />
          <div className={classes.buttonsBox}>
            <Button
              innerStyle={["toggleInvertMainButton", classes.contentButton]}
              onClick={this.onClick(false)}
              richText={{
                translate: true,
                text: '_%cancelar%_',
                innerStyle: ['uppercase', 'roboto15Black400']
              }}
              id={'td-points-cancel-00'}
            />
            <Button
              innerStyle={["toggleMainButton", classes.contentButton]}
              onClick={this.onClick(true)}
              richText={{
                translate: true,
                text: '_%continuar%_',
                innerStyle: ['uppercase', 'roboto15Black400']
              }}
              id={'td-points-continue-00'}
            />
          </div>
        </div>
      </ModalBox>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setBlockPoints : () => {
        return dispatch(actions.customer.loyalty.setBlockPointsAsync());
    },

  }
};

const mapStateToProps = store => {
  return {

  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    "closeModal",
    "setBlockPoints",
    "checkboxChange",
    "refreshBlockPoints",
    "trackingId"
  ]),
  withThemeJSS({ styleFile })
)(AlertBlockPointsModal);
